export const objDetail = "machine";
export const auth = "auth";
export const dashboard = "dashboard";
